export default __webpack_public_path__ + "static/media/servicosp6.99fdb59d.jpg";